module.exports = __webpack_public_path__ + "static/media/game-sound-failure.bcb2a1a8.mp3";